import { useNavigate } from 'react-router-dom';
import { Hash, Phone, MapPin, Calendar, ArrowRight } from 'lucide-react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';

const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function JobCard({ job }) {
  const navigate = useNavigate();

  const createdAt = job.createdAt?.toDate
    ? job.createdAt.toDate().toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric',
      })
    : '—';

  return (
    <div
      onClick={() => navigate('/cutlist/' + job.id + '/cutlist')}
      style={{
        background: PAPER,
        borderRadius: '14px',
        border: '1px solid rgba(139,69,19,0.1)',
        boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
        padding: '20px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        fontFamily: FONT_SANS,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(139,69,19,0.12)';
        e.currentTarget.style.borderColor = 'rgba(139,69,19,0.25)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.05)';
        e.currentTarget.style.borderColor = 'rgba(139,69,19,0.1)';
      }}
    >
      {/* Top row — name */}
      <div>
        <div style={{ fontFamily: FONT_DISPLAY, fontSize: '17px', fontWeight: 600, color: INK, marginBottom: '2px' }}>
          {job.customerName || 'Unnamed Customer'}
        </div>
        {job.jobName && (
          <div style={{ fontSize: '12px', color: WALNUT, fontStyle: 'italic' }}>
            {job.jobName}
          </div>
        )}
      </div>

      {/* Details row */}
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        {job.woNumber && (
          <Detail Icon={Hash} label="WO #" value={job.woNumber} />
        )}
        {job.phone && (
          <Detail Icon={Phone} label="Phone" value={job.phone} />
        )}
        {job.city && (
          <Detail Icon={MapPin} label="Location" value={[job.city, job.stateZip].filter(Boolean).join(', ')} />
        )}
        <Detail Icon={Calendar} label="Created" value={createdAt} />
      </div>

      {/* Footer */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        paddingTop: '10px', borderTop: '1px solid rgba(139,69,19,0.07)',
      }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: STONE, fontWeight: '500' }}>
          Click to open job hub <ArrowRight size={11} strokeWidth={2} />
        </span>
        <span style={{ fontSize: '11px', color: WALNUT, fontWeight: '600' }}>
          View all documents
        </span>
      </div>
    </div>
  );
}

function Detail({ Icon, label, value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      <Icon size={12} strokeWidth={2} color={STONE} />
      <span style={{ fontSize: '11px', color: STONE, fontWeight: '600' }}>{label}:</span>
      <span style={{ fontSize: '11px', color: '#555', fontWeight: '500' }}>{value}</span>
    </div>
  );
}
